import React from "react";
import AppointmentDetails from "../../Components/Doctor/Appointment/AppointmentDetails";

const DoctorAppointmentDetailsPage = () => {
  return (
    <div className="p-5">
      <AppointmentDetails />
    </div>
  );
};

export default DoctorAppointmentDetailsPage;
